export const GET_FOLDERS = 'GET_FOLDERS';
export const ADD_FOLDER = 'ADD_FOLDER';
export const FOLDER_DELETE = 'FOLDER_DELETE';
export const UPDATE_FOLDER = 'UPDATE_FOLDER';
export const SEND_NEW_FOLDER = 'SEND_NEW_FOLDER';
export const UPDATE_PARENT_ID_FOLDER = 'UPDATE_PARENT_ID_FOLDER';